import script from "./AUploadSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./AUploadSingle.vue?vue&type=script&setup=true&lang=js"

import "./AUploadSingle.vue?vue&type=style&index=0&id=ca58a9ac&scoped=true&lang=css"
import "./AUploadSingle.vue?vue&type=style&index=1&id=ca58a9ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca58a9ac"]])

export default __exports__